export const VERSION_LOCALHOST = "2.25.2(1)-local";
export const VERSION_DEVELOP = "2.25.2(1)-Dev";
export const VERSION_STAGING = "2.25.2(1)-Stg";
export const VERSION_PRODUCTION = "2.25.2";

export const VERSIONS = {
  localhost: VERSION_LOCALHOST,
  develop: VERSION_DEVELOP,
  staging: VERSION_STAGING,
  production: VERSION_PRODUCTION,
};
